import React from 'react';
import { Alert, Spin, Button, Popconfirm } from 'antd';
import { useUnblockGmailAccount } from 'mutation/gmail';
import { Row, Col } from 'components/ui';

export default function UnblockGmailAccount({ id, data }) {
  const [
    unblockGmailAccount,
    { loading: loadingUnblock },
  ] = useUnblockGmailAccount(id);

  return (
    <Spin spinning={loadingUnblock} tip="Unblocking...">
      <Row>
        <Col span={18}>
          {data.suspended_at && (
            <div
              className="flex items-center mb-3"
              style={{
                justifyContent: 'stretch',
                marginBottom: 12,
              }}
            >
              <div className="flex flex-1">
                <Alert
                  className="w-full"
                  message="This email is suspended"
                  type="warning"
                />
              </div>
              <Popconfirm
                cancelText="No"
                okText="Yes"
                title="Are you sure to unblock this email manually?"
                onConfirm={unblockGmailAccount}
              >
                <Button style={{ marginLeft: 5 }} type="primary">
                  Unblock?
                </Button>
              </Popconfirm>
            </div>
          )}
        </Col>
      </Row>
    </Spin>
  );
}
